import { render, staticRenderFns } from "./WidgetTemplate.vue?vue&type=template&id=193a42ee&scoped=true&lang=pug"
import script from "./WidgetTemplate.vue?vue&type=script&lang=ts"
export * from "./WidgetTemplate.vue?vue&type=script&lang=ts"
import style0 from "./WidgetTemplate.vue?vue&type=style&index=0&id=193a42ee&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "193a42ee",
  null
  
)

export default component.exports